import type { AllRouteEndpoints } from "../routeTypes";
export const postAppsUserInfoConfirmUserDeletionCacheKeys: AllRouteEndpoints[] = [
  "/apps/user_info/user_deletion_record_datatable",
];
